import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	Input,
	ViewChild,
	ViewContainerRef
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DatepickerHostDirective } from '@app/shared/form/directives';
import { DateInput } from '@app/shared/form/models';
import {
	NbButtonModule,
	NbDatepickerComponent,
	NbDatepickerModule,
	NbFormFieldModule,
	NbIconModule,
	NbInputModule
} from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { DatepickerHostDirective as DatepickerHostDirective_1 } from './../../../directives/datepicker-host.directive';
import { BaseInputComponent } from './../base-input/base-input.component';

type DateComponentRef = NbDatepickerComponent<Date>;

@Component({
	selector: 'app-date-input',
	template: `
		@if (datePicker) {
			<nb-form-field>
				<input
					[attr.id]="controlId"
					nbInput
					fullWidth
					fieldSize="medium"
					[type]="control.clearable ? 'search' : 'text'"
					[placeholder]="control.placeholder | translate"
					[formControl]="control"
					[nbDatepicker]="datePicker"
					[status]="control.colorStatus"
				/>
				<button
					type="button"
					nbSuffix
					nbButton
					ghost
					(click)="togglePicker()"
					[disabled]="control.disabled || control.readonly"
				>
					<nb-icon icon="calendar-outline"></nb-icon>
				</button>
			</nb-form-field>
		}

		<ng-template appDatepickerHost></ng-template>
	`,
	standalone: true,
	imports: [
		NbFormFieldModule,
		NbInputModule,
		ReactiveFormsModule,
		NbDatepickerModule,
		NbButtonModule,
		NbIconModule,
		DatepickerHostDirective_1,
		TranslateModule
	]
})
export class DateInputComponent
	extends BaseInputComponent
	implements AfterViewInit
{
	@ViewChild(DatepickerHostDirective) datepickerHost: DatepickerHostDirective;
	@Input({ required: true }) override control: DateInput;

	datePicker: DateComponentRef;
	constructor(private cdr: ChangeDetectorRef) {
		super();
	}

	ngAfterViewInit() {
		this.loadComponent();
	}

	loadComponent() {
		const viewContainerRef: ViewContainerRef =
			this.datepickerHost.viewContainerRef;
		viewContainerRef.clear();

		const componentRef = viewContainerRef.createComponent<DateComponentRef>(
			NbDatepickerComponent
		);

		componentRef.instance.format = this.control.format;
		componentRef.instance.boundingMonth = this.control.boundingMonth;
		componentRef.instance.hideOnSelect = this.control.hideOnSelect;
		componentRef.instance.showNavigation = this.control.showNavigation;
		componentRef.instance.showWeekNumber = this.control.showWeekNumber;
		componentRef.instance.weekNumberSymbol = this.control.weekNumberSymbol;
		componentRef.instance.size = this.control.calendarSize;
		componentRef.instance.min = this.control.min;
		componentRef.instance.max = this.control.max;
		componentRef.instance.filter = this.control.filter;

		setTimeout(() => {
			this.datePicker = componentRef.instance;
			this.cdr.markForCheck();
		});
	}

	togglePicker(): void {
		if (!this.datePicker.isShown) {
			setTimeout(() => {
				this.datePicker.show();
			});
		}
	}
}
